import React, { forwardRef } from 'react';

import DatePickerCustomInput from '../../DatePickerCustomInput/DatePickerCustomInput';
import { formatTime } from '../../../../../../helpers/dateHelpers';

export interface Props {
  isDisabled: boolean;
  onClick?: () => void;
  selectedDatetime?: Date;
}

const CustomInput: React.FC<Props> = forwardRef(
  ({ isDisabled, onClick, selectedDatetime }, ref) => (
    <DatePickerCustomInput
      isDisabled={isDisabled}
      onClick={onClick}
      selectedDatetime={selectedDatetime}
    >
      {selectedDatetime
        ? formatTime(new Date(selectedDatetime), { includeTimezone: true })
        : 'Select time'}
    </DatePickerCustomInput>
  ),
);

export default CustomInput;
